import React, { useState } from "react";
import { CustomButton } from "../CustomButton";
import { ShareIcon } from "../../images";
import { ShareCampaignModal } from "../modal";
import { CircularProgress } from "@mui/material";
import {
  campaignsApi,
  useChangeUsersRoleInCampaignMutation,
  useLazyGetUsersThatShareCampaignQuery,
} from "../../../api";
import { useParams } from "react-router-dom";
import { UpdateUserRoleRequest } from "../../../types/apiTypes";
import { toast } from "react-toastify";
import { CustomToast } from "../CustomToast";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { useAppDispatch } from "../../../hooks";

export const ShareCampaignBtn = ({ userEmail }: { userEmail: string }) => {
  const { campaign_id } = useParams();
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [changeUsersRoles, { isLoading: isChangeRolesLoading }] =
    useChangeUsersRoleInCampaignMutation();

  const [
    getUsersThatShareCampaign,
    { data: sharedCampaignUsers, isFetching: isUserLoading },
  ] = useLazyGetUsersThatShareCampaignQuery();

  const openHandler = () => {
    if (!campaign_id) return;
    getUsersThatShareCampaign(campaign_id)
      .unwrap()
      .then(() => setIsOpen(true));
  };

  const changeUsersRolesHandler = (updateRequest: UpdateUserRoleRequest) => {
    changeUsersRoles(updateRequest)
      .unwrap()
      .then(() => {
        toast.success(
          <CustomToast
            type={"success"}
            text={"Successfully Changed Roles for Users"}
            title={"Users Roles Changed"}
          />,
        );

        dispatch(campaignsApi.util.invalidateTags(["summary"]));
        setIsOpen(false);
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong during processing. Please try again"
            }
            title={"Failed to Change Roles"}
          />,
        );
      });
  };

  return (
    <>
      <CustomButton
        onClick={openHandler}
        variant="outlined"
        customColor="#FFFFFF"
        textColor="#1D3E70"
        customSize={"fit"}
        type="button"
        sx={{
          borderColor: "#1D3E70",
          backgroundColor: "transparent",
          justifyContent: "flex-start",
        }}
        disabled={isChangeRolesLoading || isUserLoading}
        startIcon={
          isChangeRolesLoading || isUserLoading ? (
            <CircularProgress size={24} sx={{ color: "inherit" }} />
          ) : (
            <ShareIcon />
          )
        }
      >
        Share
      </CustomButton>
      {isOpen && sharedCampaignUsers && (
        <ShareCampaignModal
          userEmail={userEmail}
          changeUsersRoles={changeUsersRolesHandler}
          sharedCampaignUsers={sharedCampaignUsers}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isLoading={isChangeRolesLoading}
        />
      )}
    </>
  );
};
